import React from "react";

const BackSpaXp = () => {
  return (
    <div className="headSpaHeadContainer">
      <h2>The SCENT Experience: Back Massage in Bangalore</h2>
      <p>
        At SCENT, the back massage experience is designed to provide
        unparalleled relaxation and healing. From the moment you step into the
        salon, you're greeted with a serene ambiance, featuring soft lighting,
        calming music, and a pleasant aroma. The salon's decor exudes luxury and
        tranquility, setting the perfect stage for a rejuvenating experience.
      </p>
    </div>
  );
};

export default BackSpaXp;
